<template>
  <div class="form-wrapper">
    <form class="page-form" @submit.prevent="sendForm">
      <div class="form-group">
        <span class="form-group__label d-block">Ваше имя</span>
        <input
          type="text"
          class="form-group__input d-block w-100"
          placeholder="..."
          v-model="name"
          ref="name"
        />
        <span class="error-message">Пустое поля</span>
      </div>
      <div class="form-group">
        <span class="form-group__label d-block">Номер телефона</span>
        <input
          type="text"
          class="form-group__input d-block w-100"
          v-mask="mask"
          v-model="phone"
          :placeholder="placeholder"
          ref="phone"
        />
        <span class="error-message">Пустое поля</span>
      </div>
      <div class="form-group">
        <span class="form-group__label d-block">Сообщение</span>
        <textarea
          class="form-group__input d-block w-100"
          placeholder="..."
          v-model="message"
          ref="message"
        ></textarea>
        <span class="error-message">Пустое поля</span>
      </div>
      <div class="form-group text-right">
        <button type="submit" class="form-group__button text-white pointer">Отправить</button>
      </div>
    </form>
    <div class="alert-wrap p-fixed rounded p-4" ref="alertSuccess">
      <div class="alert-box success">
        <p>Успешно!</p>
        <span>
          Ваша заявка успешно была оставлена!
        </span>
      </div>
    </div>
    <div class="alert-wrap p-fixed rounded p-4 is--error" ref="alertError">
      <div class="alert-box success">
        <p>Ошибка!</p>
        <span>
          Произошла ошибка!
        </span>
      </div>
    </div>
  </div>
</template>

<script>
 import { mapActions } from "vuex";

  export default {
    props: ['flat_id'],

    data() {
      return {
        mask: "+### ## ### ## ##",
        placeholder: "+998 ()",
        phone: null,
        name: null,
        message: null
      };
    },

    watch: {
      name() {
        this.$refs.name.parentElement.classList.remove("active");
      },
      phone() {
        this.$refs.phone.parentElement.classList.remove("active");
      },
      message() {
        this.$refs.message.parentElement.classList.remove("active");
      }
    },

    methods: {
      ...mapActions({
          sendClientInfo: "flats/sendClientInfo"
      }),

      sendForm() {
        if (this.flat_id) {
          const { name, phone, message, alertSuccess, alertError } = this.$refs;

          if (this.name && this.phone && this.message) {
            this.sendClientInfo({
                flat_id: this.flat_id,
                name: this.name,
                phone: this.phone,
                message: this.message
              })
              .then((res) => {
                this.name = this.phone = this.message = null;
                alertSuccess.classList.add("active");
                setTimeout(() => {
                  alertSuccess.classList.remove("active");
                }, 6500);
              })
              .catch((err) => {
                alertError.classList.add("active");
                alertError.classList.add("is--error");
                setTimeout(() => {
                  alertError.classList.remove("active");
                }, 6500);
              });
          }

          if (!this.name) {
            name.parentElement.classList.add("active");
          }
          if (!this.phone) {
            phone.parentElement.classList.add("active");
          }
          if (!this.message) {
            message.parentElement.classList.add("active");
          }
        }
      }
    }
  };
</script>

<style></style>
